import {
  SAVE_OWN_STATEMENTS,
  SAVE_STATEMENTS,
  CREATE_STATEMENT,
  UPDATE_STATEMENT,
  DELETE_STATEMENT,
  UPDATE_STATEMENT_REQUEST_LINE_STATUS
} from 'src/store/actions/statementActions';

const initialState = {
  own: null, // null || array
  list: null // null || array
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SAVE_OWN_STATEMENTS: {
      return { ...state, own: payload };
    }
    case SAVE_STATEMENTS: {
      return { ...state, list: payload };
    }
    case CREATE_STATEMENT: {
      return { ...state, list: (state.list ? [...state.list] : []).concat(payload) };
    }
    case UPDATE_STATEMENT: {
      return {
        ...state,
        list: state.list
          ? state.list.map((entry) => (entry.Id === payload.Id ? payload : entry))
          : [payload]
      };
    }
    case DELETE_STATEMENT: {
      return {
        ...state,
        list: state.list
          ? state.list.filter((entry) => entry.Id !== payload)
          : []
      };
    }
    case UPDATE_STATEMENT_REQUEST_LINE_STATUS: {
      const { parentRequestId, status } = payload;
      const requestLineId = status.TypeValueId;
      if (!state.list?.length) {
        return state;
      }
      return {
        ...state,
        list: state.list.map((request) => {
          if (request.Id === parentRequestId) {
            return {
              ...request,
              RequestLines: request.RequestLines.map((line) => (line.Id === requestLineId ? { ...line, Status: status } : line))
            };
          }
          return request;
        })
      };
    }
    default: {
      return state;
    }
  }
};
